import Confetti from "canvas-confetti";

export default function getConfetti() {
  const colors = ["#782CE8", "#C99CFD", "#E1CBFB", "#F2EAFA", "#FADC41"];
  const count = 200;
  const defaults = {
    colors: colors,
    origin: { y: 0.7 },
    zIndex: 9999,
    // 纸片大小
    // scalar: 2,
    // 出现的角度
    // angle: 97,
    // 纸片移动次数
    // ticks: 500,
  };

  const fire = (
    particleRatio: number,
    opts: { [key: string]: number | string[] }
  ) => {
    Confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      })
    );
  };

  fire(0.25, {
    // 扩散
    spread: 26,
    // 开始的速度
    startVelocity: 55,
    // 形状 只能出现圆形 跟矩行 bad
    // shapes: ["circle", "circle", "square"],
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}
